export var ProductTicketLatestStatus;
(function (ProductTicketLatestStatus) {
    ProductTicketLatestStatus["Active"] = "active";
    ProductTicketLatestStatus["ReminderSent"] = "reminderSent";
    ProductTicketLatestStatus["ReminderOpened"] = "reminderOpened";
    ProductTicketLatestStatus["Canceled"] = "canceled";
    ProductTicketLatestStatus["CheckedIn"] = "checked-in";
})(ProductTicketLatestStatus || (ProductTicketLatestStatus = {}));
